import { Box, Typography, Container, Tab, useTheme, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import Carousel from 'react-material-ui-carousel'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams } from 'react-router-dom'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Ingredients } from './Ingredients'
import { Instructions } from './Instructions'
import StarRatings from 'react-star-ratings'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
export const RecetteDetails = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [infoshow, setInfoShow] = useState(true)
  const { id } = useParams()
  const [recette, setRecette] = useState({})
  const [value, setValue] = React.useState('1')
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  useEffect(() => {
    fetchRecetteDetail()
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const fetchRecetteDetail = async () => {
    const response = await makeGetRequest(urls.crudRecettesOperations + id, {}, true)
    if (response.status === 200) {
      setRecette(response.data)
    }
  }

  const displayColumn = (name, value, postfix = '', Icone = '') => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography color="secondary">{name} : </Typography>
      <WTypography variant="span" sx={{ marginLeft: '5px', color: 'white', fontWeight: '700' }}>
        {value || 'N/A'} {postfix || ''}
      </WTypography>
    </Box>
  )

  const Général = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Général</WTypography>
      <Box>
        <Typography sx={{ color: '#adadad' }}>{recette.Description}</Typography>
      </Box>
    </Box>
  )
  const ingredients = (
    <>
      {/* <Box sx={{ borderBottom: '2px solid' }} display={'flex'} p={1} mt={2}>
      </Box> */}
      <Box display={'flex'} gap={2} p={0} mt={2} flexDirection={isMobile ? 'column' : 'row'}>
        <Box width={isMobile ? '100%' : '45%'}>
          <Box fontSize={25}>Ingrédients</Box>
          <Ingredients recette={recette} />
        </Box>
        <Box width={isMobile ? '100%' : '55%'}>
          <Box fontSize={25}>Instruction</Box>
          <Instructions recette={recette} />
        </Box>
      </Box>
    </>
  )
  const video = (
    <>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} p={1} mt={5}>
        <Box>
          <video width="720" id="rece_id" height="440" controls>
            <source src={recette.LienVideo} />
          </video>
        </Box>
      </Box>
    </>
  )

  const GoldStar = ({ rating }) => {
    const [ratings, setRatings] = useState(rating)

    const changeRating = (e) => {
      setRatings(e)
      const formData = new FormData()
      const payload = {
        id: recette.id,
        Nom: recette.Nom,
        PlatsPreferee: e,
      }
      for (const key in payload) {
        formData.append(`${key}`, `${payload[key]}`)
      }
      makePutRequest(
        urls.crudRecettesOperations + `${payload.id}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      )
    }

    return (
      <StarRatings
        rating={ratings}
        starRatedColor="gold"
        starHoverColor="gold"
        changeRating={changeRating}
        numberOfStars={5}
        starDimension="25px"
        name="rating"
      />
    )
  }
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms))
  return (
    <>
      <Container maxWidth="lg">
        <Box
          display={'flex'}
          flexDirection={'column'}
          px={isMobile ? 1 : 4}
          // fontSize={isMobile ? '70%' : '100%'}
          py={1}
        >
          <Box display={'flex'} alignItems={'center'}>
            <WTypography sx={{ color: '#fff', fontSize: '1.6rem' }}>{recette.Nom}</WTypography>
            <WTypography sx={{ color: '#ababab', marginLeft: '5px' }}>
              {recette.typeDePlat?.Name}
            </WTypography>
          </Box>
          <Box
            display={'flex'}
            flexDirection={isMobile ? 'column' : 'row'}
            width={'100%'}
            justifyContent={'space-between'}
            mt={4}
            gap={3}
          >
            <Box
              display={'flex'}
              justifyContent={'start'}
              alignItems={'center'}
              width={'100%'}
              // height="110px"
              px={isMobile ? 1 : 4}
            >
              <img key="carLogo" src={recette.Image} alt="img" />
            </Box>
            {/* <Box display={'flex'} alignItems={'center'} width="100%"> */}
            <Box
              display={infoshow ? 'flex' : 'none'}
              justifyContent="start"
              flexDirection="column"
              width={'100%'}
            >
              <Box>
                {displayColumn(
                  'Temps total ',
                  recette.TempsTotalH + ' H ' + recette.TempsTotalMin + ' min',
                )}
              </Box>
              <Box>
                {displayColumn(
                  'Temps de préparation',
                  recette.TempsDePreparationH + ' H ' + recette.TempsDePreparationMin + ' min',
                )}
              </Box>
              <Box>
                {displayColumn(
                  'Temps de caisson ',
                  recette.TempsDeCuissonH + ' H ' + recette.TempsDeCuissonMin + ' min',
                )}
              </Box>
              <Box>{displayColumn('Servir', recette.Servir + ' pers.')}</Box>
              <Box>{displayColumn('Catégorie', recette.categorie?.Name)}</Box>
            </Box>
            <Box width={'100%'} sx={{ display: infoshow ? 'block' : 'none' }}>
              <Box>{displayColumn('Type de plats', recette.typeDePlat?.Name)}</Box>
              <Box>{displayColumn('Type de cuisine', recette.typeDeCuisine?.Name)}</Box>
              <Box>
                {displayColumn('Plats préférée ', <GoldStar rating={recette.PlatsPreferee} />)}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleChange}
                sx={{ '.MuiTabs-flexContainer': { overflow: 'auto' } }}
              >
                <Tab sx={{ color: 'white' }} label="Général" value="1" />
                <Tab sx={{ color: 'white' }} label="Ingredients/Instructions" value="2" />
                {/* <Tab
                  sx={{ color: 'white' }}
                  label="Vidéo"
                  value="3"                 
                /> */}
              </TabList>
            </Box>
            <TabPanel value="1">
              <Box color={'white'}>{Général}</Box>
            </TabPanel>
            <TabPanel value="2" sx={{ px: isMobile ? 0 : 1 }}>
              <Box color={'white'}>{ingredients}</Box>
            </TabPanel>
            {/* <TabPanel value="3">
              <WTypography variant="h6">{video}</WTypography>
            </TabPanel> */}
          </TabContext>
        </Box>
      </Container>
    </>
  )
}
